import { makeStyles } from '@mui/styles';
import { colors } from '../../styles/css/colors';

const useHeaderStyles = makeStyles({
  header: {
    backgroundColor: '#f6f8fa',
    color: colors.DARKGREY,
    'padding-top': '2.5px',
    'padding-bottom': '2.5px',
    padding: '0.5rem 1.2rem',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
    minHeight: 44,
    zIndex: 10,
  },
  title: {
    margin: 0,
    fontSize: '1.5rem',
    fontWeight: 700,
    letterSpacing: 1,
  },
  userInfo: {
    textAlign: 'right',
    marginRight: '1rem',
  },
  username: {
    fontSize: '0.95rem',
    fontWeight: 500,
  },
  email: {
    fontSize: '0.85rem',
    opacity: 0.8,
  },
  signOutBtn: {
    backgroundColor: colors.PRIMARY,
    color: colors.DARKGREY,
    border: 'none',
    padding: '0.5rem 1.2rem',
    borderRadius: 4,
    cursor: 'pointer',
    fontWeight: 700,
    marginLeft: '1rem',
    '&:hover': {
      backgroundColor: colors.LIGHTYELLOW,
      color: colors.BLACK,
    },
  },
  right: {
    display: 'flex',
    alignItems: 'center',
    gap: '1rem',
  },
});

export default useHeaderStyles;
